import React from "react";
import PropTypes from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import GridContainer from "components/grid/GridContainer.js";
import GridItem from "components/grid/GridItem.js";
import Card from "components/card/Card.js";
import CardHeader from "components/card/CardHeader.js";
import CardBody from "components/card/CardBody.js";
import yellowTape from "assets/img/yellow-tape-co-name.png"
import greenTape from "assets/img/green-tape-co-name-brand.png"
import whiteTape from "assets/img/white-tape-co-name-square.png"

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle.jsx";
import { connect } from 'react-redux'
import { compose } from 'redux'
import {Elements, StripeProvider} from 'react-stripe-elements';
import CheckoutForm from './CheckoutForm';
import { getBillingTransactions, getCardOnFile } from 'store/actions/billingActions';



class BillingPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      alert: null
    };
  }
  



  hideAlert() {
      this.setState({alert: null});
  }

  render() {
    const { classes, auth, cardOnFile, nextBillingPeriod, trialEndDate, transactions, transactionsRetrieved } = this.props;
    
    if ((cardOnFile === null || cardOnFile === undefined)) {
      this.props.getCardOnFile();
      return (<div>Retrieving billing info...</div>)
    }

    if (!transactionsRetrieved) {
      this.props.getBillingTransactions();
    }
    return (
      <div>

      {!cardOnFile  ?  
      (<div><span>Trial period ends on: {trialEndDate}</span> 
      <StripeProvider apiKey="pk_test_KC2B4WlVISn6qdsjJHZa5TeC">
        <div className="example">
          
          <Elements>
            <CheckoutForm />
          </Elements>
        </div>
      </StripeProvider>
      </div>
      ) : (<span>Next billing period: {nextBillingPeriod}</span>)}

      { transactions && transactions.map(transaction => {
            return (
              <div>{transaction.description} &nbsp; {transaction.amount}<br/>
              </div>
                
            )
            })
          }
          
      </div>
      
    );
  }
}

BillingPage.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    
        
        getBillingTransactions: () => dispatch(getBillingTransactions()),
        getCardOnFile: () => dispatch(getCardOnFile())
  }
}
const mapStateToProps = (state, ownProps) => {
  console.log(state);
  
  return {
    auth: state.firebase.auth,
    cardOnFile: state.billing.cardOnFile,
    //nextBillingPeriod: state.billing.nextBillingPeriod,
    trialEndDate: state.billing.trialEndDate,
    transactions: state.billing.transactions,
    transactionsRetrieved: state.billing.transactionsRetrieved
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(pricingPageStyle)
)(BillingPage)



// WEBPACK FOOTER //
// ./src/components/billing/BillingPage.js